import { POSTHOG_TRACKING_EVENTS, PosthogTrackingSource } from '../constants';
import { CaptureTrackingEvent } from './types';

export type OnboardingPathType =
  | 'have_a_list'
  | 'build_with_alfred'
  | 'templates';

export const createOnboardingEvents = (
  captureTrackingEvent: CaptureTrackingEvent
) => {
  const trackOnboardingPathSelected = (
    source: PosthogTrackingSource,
    type: OnboardingPathType
  ) =>
    captureTrackingEvent({
      eventName: POSTHOG_TRACKING_EVENTS.ONBOARDING_PATH_SELECTED,
      properties: { source, type },
    });

  return {
    trackOnboardingPathSelected,
  };
};
